import { CalendarState, OwnerPage } from "burde";
import { CalendarDimensions } from "svg/constants";
import { D3Selection } from "svg/draw/draw-calendar";
import { elementIdentifiers } from "svg/draw/dynamic-layout/constants";
import { cultureCountries, DefaultCulture, DefaultSize } from "ui/constants";

const drawOwnerPage = (
    base: D3Selection,
    calendar: CalendarState,
    calendarId: number | null,
    ownerPageImageUrl: string | null,
    ownerPage: OwnerPage | null,
    customOrderId: string | null,
    isSpreadRoute: boolean,
) => {
    const calendarSize =
        calendar.calendarSize !== "" ? calendar.calendarSize : DefaultSize;
    const calendarDimensions = CalendarDimensions.find(
        (x) => x.calendarSize === calendarSize,
    );

    if (calendarDimensions == undefined) return;

    let container = !isSpreadRoute
        ? base.append("div").attr("class", "svg-container")
        : base;

    let svg = container
        .append("svg")
        .attr("width", "100%")
        .attr("height", "100%")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .classed("svg-content", true);

    // Default SVG here
    if (ownerPage !== null) {
        svg.append("g").html(
            ownerPage.endpoints.svgData !== undefined
                ? ownerPage.endpoints.svgData
                : "",
        );
    }

    // Owner image
    if (ownerPageImageUrl !== null && ownerPageImageUrl !== "") {
        const imageElement = svg.select(
            elementIdentifiers.ownerPage.ownerImage,
        );
        imageElement.attr(
            "href",
            ownerPageImageUrl != null ? ownerPageImageUrl : "",
        );
    }

    if (calendar.ownerPage === null) return;

    const name = calendar.ownerPage.name || "";
    svg.select(elementIdentifiers.ownerPage.name).select("tspan").text(name);

    const email = calendar.ownerPage.email || "";
    svg.select(elementIdentifiers.ownerPage.email).select("tspan").text(email);

    const phoneNumber = calendar.ownerPage.phoneNumber || "";
    svg.select(elementIdentifiers.ownerPage.phone)
        .select("tspan")
        .text(phoneNumber);

    const greeting = calendar.ownerPage.greeting || "";
    svg.select(elementIdentifiers.ownerPage.greeting)
        .select("tspan")
        .text(greeting);

    if (customOrderId !== null) {
        svg.select(elementIdentifiers.ownerPage.orderId)
            .select("tspan")
            .text(customOrderId);
    } else if (calendarId !== null) {
        const cultureCountry =
            calendar.culture !== null
                ? cultureCountries.find((x) => x.culture === calendar.culture)
                : cultureCountries.find((x) => x.culture === DefaultCulture);
        const countryPrefix =
            cultureCountry !== undefined ? cultureCountry.country : "";

        svg.select(elementIdentifiers.ownerPage.orderId)
            .select("tspan")
            .text(`${countryPrefix}-${calendarId}`);
    }
};

export { drawOwnerPage };
